import { render } from "./BlueCat.svg?vue&type=template&id=7071d8af"
const script = {}
script.render = render

export default script